import React from 'react'
import '../css/Mobile/CustomerInfo.css'
import User from '../images/Mobile/UserMale1.png'

function CustomerInfo({button}) {
  return (
    <div className='CustomerInfoMobileContainer font-nunito w-[80%] h-max bg-[#f0f0f0] shadow-[1px_1px_20px_rgba(0,0,0,0.4)]'>
        <div className='CustomerInfoMobileContainer_title p-2 gap-1'>
            <img className='w-[1.25rem]' src={User} alt="?" />
            <span className='mt-[.2rem]'>Customer Information</span>
        </div>
        <div className='flex flex-col w-full h-max p-3 gap-3 text-nowrap'>
            <div className='w-full flex justify-center items-center gap-3'>
                <div className='w-1/2 flex flex-col gap-1'>
                    <span>Table No.</span>
                    <input className='w-full p-1' type="number" name="" id="" />
                </div>
                <div className='w-1/2 flex flex-col gap-1'>
                    <span>Waiter Name</span>
                    <input className='w-full p-1' type="text" name="" id="" />
                </div>
            </div>
            <div className='CustomerInfoMobileContainer_ContentInputsName'>
                <div className='CustomerInfoMobileContainer_ContentInputsDivCustomerName gap-1'>
                    <span>Customer Name</span>
                    <input className='w-full p-1' type="text" name="" id="" />
                </div>
            </div>
            <div className='CustomerInfoMobileContainer_ContentInputsWaiter'>
                <div className='CustomerInfoMobileContainer_ContentInputsDiv gap-1'>
                    <span>Total Persons</span>
                    <input className='w-full p-1' type="text" name="" id="" />
                </div>
            </div>
            <div className='w-full flex gap-3 mt-3 text-[#fff] text-[1rem] font-[600]'>
                <button className='w-1/2 flex justify-center items-center bg-[#0008B4] p-2 rounded-[.313rem] tracking-wide' onClick={button}>Cancel</button>
                <button className='w-1/2 flex justify-center items-center bg-[#0008B4] p-2 rounded-[.313rem] tracking-wide'>Submit</button>
            </div>
        </div>
    </div>
  )
}

export default CustomerInfo
